import { getData, postData } from '@/assets/js/api.js'

//添加恒照度
export const Create = (params, fn) => {
	let methods = '/api/ConstIllumination/CreateNew';
	postData(methods, params, 1, fn);
};

//修改恒照度
export const Edit = (params, fn) => {
	let methods = '/api/ConstIllumination/Edit';
	postData(methods, params, 1, fn);
};

//查询用户设置的恒照度详情
export const Find = (params, fn) => {
	let methods = '/api/ConstIllumination/FindNew';
	getData(methods, params, 1, fn);
};

//删除恒照度
export const DeleteConst = (params, fn) => {
	let methods = '/api/ConstIllumination/Delete';
	getData(methods, params, 1, fn);
};

//查询恒照度设备列表(简约信息+含设备是否被其他恒照度规则占用)
export const ChooseActionDeviceListIlluminat = (params,fn) => {
	let methods = '/api/ConstIllumination/ChooseActionDeviceList';

	return getData(methods, params, 1, fn);
};

//开启IFTTT
export const OpenConst = (params, fn) => {
	let methods = '/api/ConstIllumination/Open';
	getData(methods, params, 1, fn);
};

//关闭IFTTT
export const CloseConst = (params, fn) => {
	let methods = '/api/ConstIllumination/Close';
	getData(methods, params, 1, fn);
};

